<script setup>
import { computed, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import TaskCardContent from './TaskCardContent.vue';
import { buildTaskAISuggestions } from './taskAISuggestions.js';

const { t } = useI18n();
const suggestionState = reactive({});

const suggestedTasks = computed(() => buildTaskAISuggestions(t));

const setStatus = (id, status) => {
  suggestionState[id] = status;
};
</script>

<template>
  <div class="flex h-full min-h-0 flex-col">
    <div class="min-h-0 flex-1 overflow-y-auto p-3">
      <div
        v-for="task in suggestedTasks"
        :key="task.id"
        class="mb-3 rounded-lg border border-n-violet-5 bg-n-solid-1 shadow-sm"
      >
        <div class="px-4 py-3">
          <TaskCardContent
            :task="task"
            :contact-name="task.contactName"
            :project-title="task.projectTitle"
            :type-label="task.typeLabel"
          />
        </div>

        <div
          class="flex justify-end gap-2 border-t border-n-weak px-4 py-2"
          :class="{ 'opacity-60': suggestionState[task.id] }"
        >
          <button
            type="button"
            class="rounded-lg px-3 py-1.5 text-xs font-semibold text-n-slate-10 transition hover:bg-n-alpha-2 hover:text-n-slate-12"
            @click="setStatus(task.id, 'REJECTED')"
          >
            {{ t('TASKS.AI_SUGGESTIONS.ACTIONS.REJECT') }}
          </button>
          <button
            type="button"
            class="rounded-lg bg-n-violet-9 px-3 py-1.5 text-xs font-semibold text-white transition hover:bg-n-violet-10"
            @click="setStatus(task.id, 'ACCEPTED')"
          >
            {{ t('TASKS.AI_SUGGESTIONS.ACTIONS.ACCEPT') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
